import { Injectable, WritableSignal, signal, inject } from '@angular/core';

import { Sizes, SizesGap } from '@models/sizes.model';
import { SsrService } from '@services/ssr.service';

@Injectable({
  providedIn: 'root',
})
export class SizesService {
  private ssrService = inject(SsrService);
  public gap: WritableSignal<number> = signal(48);
  public gapSection: WritableSignal<number> = signal(120);
  public mediaQueries: Sizes = {
    xs: 400,
    sm: 825,
    md: 1000,
    lg: 1280,
  };
  public mediaQuery: WritableSignal<string> = signal('md');
  public resolution: WritableSignal<number> = signal(1240);
  public isXs: WritableSignal<boolean> = signal(false);
  public isSm: WritableSignal<boolean> = signal(false);
  public isMd: WritableSignal<boolean> = signal(false);
  public isLg: WritableSignal<boolean> = signal(false);

  setSizes(): void {
    this.setDefaultGap();
    this.setMediaQuery();
  }

  setDefaultGap(): void {
    const width: number = this.ssrService.getWindow()?.innerWidth ?? 1240;
    if (width < 725) {
      this.gap.set(16);
    } else {
      this.gap.set(48);
    }
    if (width < 1000) {
      this.gapSection.set(80);
    } else if (width < 725) {
      this.gapSection.set(56);
    } else {
      this.gapSection.set(120);
    }
  }

  setMediaQuery(): void {
    const resolution = this.ssrService.getWindow()?.innerWidth ?? 1240;
    this.resolution.set(resolution);
    this.isXs.set(false);
    this.isSm.set(false);
    this.isMd.set(false);
    this.isLg.set(false);
    this.mediaQuery.set('xl');
    if (resolution < this.mediaQueries.lg) {
      this.mediaQuery.set('lg');
      this.isLg.set(true);
    }
    if (resolution < this.mediaQueries.md) {
      this.mediaQuery.set('md');
      this.isMd.set(true);
    }
    if (resolution < this.mediaQueries.sm) {
      this.mediaQuery.set('sm');
      this.isSm.set(true);
    }
    if (resolution < this.mediaQueries.xs) {
      this.mediaQuery.set('xs');
      this.isXs.set(true);
    }
  }

  getGap(gap?: SizesGap, gapMedia?: { [key: string]: SizesGap | undefined }): number | undefined {
    const resolution: number = this.ssrService.getWindow()?.innerWidth ?? 1240;
    let newGap: number | undefined = this.gap();
    if (gapMedia) {
      if (gapMedia['xs'] && resolution < this.mediaQueries.xs) newGap = this.getGapItem(gapMedia['xs']);
      else if (gapMedia['sm'] && resolution < this.mediaQueries.sm) newGap = this.getGapItem(gapMedia['sm']);
      else if (gapMedia['md'] && resolution < this.mediaQueries.md) newGap = this.getGapItem(gapMedia['md']);
      else if (gapMedia['lg'] && resolution < this.mediaQueries.lg) newGap = this.getGapItem(gapMedia['lg']);
      else newGap = this.getGapItem(gap);
    } else {
      newGap = this.getGapItem(gap);
    }
    return newGap;
  }

  getGapItem(gap?: SizesGap): number | undefined {
    if (gap) {
      if (gap === 'default') {
        return this.gap();
      } else if (gap === 'section') {
        return this.gapSection();
      } else {
        return gap;
      }
    } else {
      return undefined;
    }
  }
}
